function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M200.7 145.1l-23.5 44.6-.2-48.3h-43.6l-5.7-63.6h-101L21 197.3c-13 8-21 22.1-21 37.4v4.2c0 24.2 20.2 44.6 44.1 44.6h111.6c12.9 0 25.1-5.9 33.2-16.1 5.6.5 11.2.8 16.8.7 18.8 0 41.4-2 53.4-3.2l24.4-2.4-82.8-117.4zM148.4 191H50l1-21.1h97.5l-.1 21.1zm-46.9-84.7l3.2 35.1H52.3l1.6-35.1h47.6zm54.1 148.6H44.1c-8.1 0-15.5-7.6-15.5-16v-4.2c0-8.3 6.8-15.1 15.1-15.1h111.6c8.3 0 15.1 6.8 15.1 15.1v4.2c0 8.6-6.8 16-14.8 16zm43.3-15.3v-4.9c0-6.1-1.3-12.2-3.8-17.8l9.1-17.2 27.4 38.9c-12.6.8-24.5 1.2-32.7 1z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "52.9",
  cy: "237.3",
  r: "10.7"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "144.9",
  cy: "237.3",
  r: "10.7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 42.5h-33.4L262.3 0l-56.7 70.9H239l-12.1 42.5z"
})));